// extracted by mini-css-extract-plugin
export default {"container_failed":"AuthenticationCheck_container_failed__JzjqT","box":"AuthenticationCheck_box__Wx8hI"};